import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {catchError, concatMap, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {EMPTY, of} from 'rxjs';
import { EventMonitoringActionTypes, EventMonitoringActions } from '../actions/event-monitoring.actions';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import * as featureActions from '../../index';
import {EventsService} from '../../../services/events.service';


@Injectable()
export class EventMonitoringEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private eventsService = inject(EventsService);

  constructor() {}

  getEventMonitorings$ = createEffect(() => this.actions$.pipe(
    ofType(EventMonitoringActionTypes.GetEventMonitorings),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      // 創建新對象副本以避免修改只讀的 action payload (NgRx 9 immutability)
      const params: any = { ...action.payload, otp: user.otp };
      if (params.startDate.constructor === Date) {
        params.startDate = params.startDate.getTime() / 1000;
      }
      if (params.endDate.constructor === Date) {
        params.endDate = params.endDate.getTime() / 1000;
      }
      return this.eventsService.ReadEventByAdmin(params).pipe(
        switchMap(res => {
          const dcodeList = res.msg.body.map((i) => i.dcode);
          if (res.result && Array.isArray(res.msg.body)) {
            return of(new featureActions.LoadEventMonitorings(res.msg.body), new featureActions.GetDevices(dcodeList));
          } else {
            return [new featureActions.LoadEventMonitorings([])];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.LoadEventMonitorings([]));
        })
      );
    })
  ));



}
